export const isNewerVersion = (latestVersion: string, currentVersion: string): boolean => {
  const latestParts = latestVersion.split('.')
  const currentParts = currentVersion.split('.')

  for (let index = 0; index < Math.max(latestParts.length, currentParts.length); index++) {
    const difference = Number(latestParts[index] ?? 0) - Number(currentParts[index] ?? 0)

    if (difference !== 0) return difference > 0
  }

  return false
}
